import ModalHOC from '@/src/constrains/ModalHOC';
import { get } from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';
import DragNDropColumns from 'src/components/DragNDropColumns';
import TextAndEditIcon from 'src/components/DragRowDisplay/TextAndEditIcon';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  EFooterMenuType,
  generateFooterMenuNewOption,
} from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/common';
import { onFooterMenuOptionChange } from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/slice';
import { i18nGet } from 'src/tools/tools';
import { ActionType } from 'src/types/common/common';
import Edit from './Edit';
import css from './css.module.less';
const FooterMenuCol = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    data,
    modalOp,
    level,
    navigationList,
    occupiedSpecificField,
    isPrimary,
  } = props;
  const { setShowModal, setModalTitle, setModalContent, onModalCancel } =
    modalOp;
  //console.log('navigationList', navigationList);
  const d = useDispatch();
  const handleOnSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    const type = ActionType.reorder;
    d(
      onFooterMenuOptionChange({
        type,
        from: oldIndex,
        to: newIndex,
        level,
      }),
    );
  };

  const handleOnAdd = () => {
    const _data = generateFooterMenuNewOption();
    setShowModal(true);
    setModalTitle(getI18n('salesChannelContent.index.addMenuItem'));
    setModalContent(
      <Edit
        isPrimary={isPrimary}
        data={_data}
        navigationList={navigationList}
        onCancel={onModalCancel}
        occupiedSpecificField={occupiedSpecificField}
        onConfirm={(data) => {
          const type = ActionType.add;
          d(
            onFooterMenuOptionChange({
              type,
              target: data,
              level,
            }),
          );
        }}
      />,
    );
  };

  const handleOnModify = (data, index) => {
    const type = ActionType.modify;
    d(
      onFooterMenuOptionChange({
        type,
        target: data,
        level,
        index,
      }),
    );
  };

  const handleOnChildGenerate = (data, index) => {
    const { menuItemType, title } = data;

    const nameGenerate = () => {
      if (menuItemType === EFooterMenuType.TextLink) {
        return title;
      }
      if (menuItemType === EFooterMenuType.NavigationGroup) {
        const uuid = get(data, 'navigationGroups');
        const target = navigationList.find((i) => i.uuid === uuid);
        return (
          get(target, 'title') || getI18n('salesChannelContent.index.menuItem')
        );
      }
      if (menuItemType === EFooterMenuType.LocationSelector) {
        return getI18n('general.hOCTitle.locationSelector');
      }
      if (menuItemType === EFooterMenuType.LanguageSelector) {
        return getI18n('general.hOCTitle.languageSelector');
      }
      if (menuItemType === EFooterMenuType.CurrencySelector) {
        return getI18n('general.hOCTitle.currencySelector');
      }
      if (menuItemType === EFooterMenuType.SocialMedia) {
        return getI18n('general.hOCTitle.socialMedia');
      }
    };
    const canEdit = menuItemType === EFooterMenuType.TextLink;
    return (
      <TextAndEditIcon
        name={nameGenerate()}
        {...(canEdit
          ? {
              onClick: () => {
                setShowModal(true);
                setModalTitle(
                  getI18n('salesChannelContent.index.editMenuItem'),
                );
                setModalContent(
                  <Edit
                    isPrimary={isPrimary}
                    data={data}
                    navigationList={navigationList}
                    onCancel={onModalCancel}
                    occupiedSpecificField={occupiedSpecificField}
                    onConfirm={(data) => {
                      handleOnModify(data, index);
                    }}
                  />,
                );
              },
            }
          : {})}
      />
    );
  };
  return (
    <DragNDropColumns
      hideAdd
      titleRightText={
        isPrimary ? (
          <div className={css.addNew} onClick={handleOnAdd}>
            {getI18n('salesChannelContent.index.addMenuItem')}
          </div>
        ) : (
          <div />
        )
      }
      title={`${getI18n('salesChannelContent.index.footerColumn')} ${level}`}
      childGenerate={handleOnChildGenerate}
      data={data}
      droppableId={`salesChannelContentFooterMenu${level}`}
      onSort={handleOnSort}
      disabled={!isPrimary}
      {...(isPrimary
        ? {
            onDelete: (index) => {
              const type = ActionType.delete;
              d(
                onFooterMenuOptionChange({
                  index,
                  type,
                  level,
                }),
              );
            },
          }
        : {})}
    />
  );
};

export default ModalHOC(FooterMenuCol, { width: 600 });
